import { ComponentConfig } from '@measured/puck';
import {
  spacingOptions,
  boxShadows,
} from '../../../../page-builder/puck/reusable-props/options';
import CustomTooltip from '../../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../../services/constants';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  resolveShowComponentField,
} from '../../../utils/helper';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import { marginFields, MarginProps } from '../../../puck/reusable-props/margin';
import {
  paddingFields,
  PaddingProps,
} from '../../../puck/reusable-props/padding';
import { backgroungFields } from '../../../puck/reusable-props/backgroungFields';

export type VerticalSpaceProps = {
  size: string;
  background: {
    color: string;
    isInherit: boolean;
  };
  border: IBorderValueProps;
  boxShadow: 'none' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl';
} & showComponentProps &
  MarginProps &
  PaddingProps;

export const VerticalSpace = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<VerticalSpaceProps> => {
  return {
    label: (
      <CustomTooltip title="VerticalSpace">
        <span>Vertical Space</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...marginFields,
      ...paddingFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border
            value={value}
            onChange={onChange}
            title="Border"
            showWidthProps={true}
          />
        ),
      },
      ...backgroungFields,
      size: {
        type: 'select',
        options: spacingOptions,
      },
      boxShadow: {
        label: 'Shadow',
        type: 'select',
        options: boxShadows,
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      boxShadow: 'none',
      size: '24px',
      background: {
        color: '#ffffff',
        isInherit: false,
      },
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      margin: {
        desktop: {
          top: '4',
          bottom: '4',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      ...borderProps,
    },
    resolveFields: ({ props }, { fields }) =>
      resolveShowComponentField(props.id, fields),
    render: ({
      size,
      background,
      showComponent,
      editMode,
      boxShadow,
      padding,
      margin,
      border,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);

      return (
        <>
          {showComponent?.includes(currentDeviceType) && (
            <div
              className={`${border?.borderStyle?.[currentDeviceType]} ${boxShadow}`}
              style={{
                ...marginStyles,
                height: size,
                width: '100%',
                backgroundColor: background?.isInherit
                  ? 'inherit'
                  : background?.color,
                ...getPaddingStyles(padding, currentDeviceType),
                ...getBorderProps(border, currentDeviceType, true),
              }}
            />
          )}
        </>
      );
    },
  };
};
